import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import ourStaff from '../../../helpers/ourStaff';

import TopDashboard from './Dashboard/TopDashboard.js';
import FlopDashboard from './Dashboard/FlopDashboard.js';
import NoMatch from '../../NoMatch';

const championshipsByPlatform = { 'mpg': 1, 'mln': 2, 'mgd': 3};
const Topflop = props => (
    <div id="players">
        { !props.location.search ? (
            <Redirect to={{
                pathname: '/topflop/top',
                search: `?championship=${championshipsByPlatform[props.user.mainPlatform]}`,
            }}/>
        ) : (
            <Switch>
              <Route path='/topflop/top' component={TopDashboard} />
              <Route path='/topflop/flop' component={FlopDashboard} />
              <Route component={NoMatch} />
            </Switch>
        )}
    </div>
);

Topflop.propTypes = {
    user: PropTypes.object.isRequired
};

export default connect(
    state => ({ user: ourStaff[state.authentication.userId] || state.authentication.user || {} })
)(Topflop);



// WEBPACK FOOTER //
// ./src/pages/Tools/Topflop/index.js